import { render, staticRenderFns } from "./EvaluateResultDialog.vue?vue&type=template&id=2ddcaf3f&scoped=true"
import script from "./EvaluateResultDialog.vue?vue&type=script&lang=js"
export * from "./EvaluateResultDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddcaf3f",
  null
  
)

export default component.exports